const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Vanshika Srivastava</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Management and Records Head, UPES-CSI</li>
    <li>
        Overseeing administrative operations.
    </li>
    <li>
        Maintaining accurate records and documentation.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
